import type { IBrowser, IOS } from 'ua-parser-js'
import UAParser from 'ua-parser-js'

import type {
  BoundingBox,
  Browser as ApiBrowser,
  OS as ApiOS,
  UserDeviceInfo as ApiUserDeviceInfo,
} from './__generated__/data-contracts'

export type BoundingBoxGeometry = {
  xMax: number
  xMin: number
  yMax: number
  yMin: number
  xStep: number
  yStep: number
}

export const convertToGeometry = (boundingBox: BoundingBox): BoundingBoxGeometry => {
  const { maxX: xMax, maxY: yMax, minX: xMin, minY: yMin } = boundingBox
  return { xMax, xMin, yMax, yMin, xStep: 100, yStep: 100 }
}

export const getUserDeviceInfo = (): ApiUserDeviceInfo => {
  const userAgentParser = new UAParser(window.navigator.userAgent)
  const os = convertOS(userAgentParser.getOS())
  const browser = convertBrowser(userAgentParser.getBrowser())
  return { browser, os }
}

const convertOS = (os: IOS): ApiOS => ({
  name: os.name,
  version: os.version,
})

const convertBrowser = (browser: IBrowser): ApiBrowser => ({
  name: browser.name,
  version: browser.version,
})
